import React from "react";
import { Helmet } from "react-helmet";

const AboutPage = ({ setCurrentPage }) => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>About OpticPicker - Optics Price Comparison</title>
        <meta name="description" content="Learn about OpticPicker — built to help hunters, shooters, and outdoor enthusiasts find the best deals on optics from top retailers." />
        <meta property="og:title" content="About OpticPicker" />
        <meta property="og:url" content="https://www.opticpicker.com/about" />
        <link rel="canonical" href="https://www.opticpicker.com/about" />
      </Helmet>
      <div className="max-w-4xl mx-auto px-6 py-20">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
            About OpticPicker
          </h1>
          <p className="text-xl text-gray-300">
            Your trusted source for optics price comparison
          </p>
        </div>

        <div className="space-y-8">
          <div className="bg-gray-800/40 backdrop-blur-sm border border-gray-700/50 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Our Mission</h2>
            <p className="text-gray-300 leading-relaxed">
              OpticPicker was built to help shooters, hunters, and outdoor
              enthusiasts find the best deals on quality optics. We aggregate
              prices from top retailers across the web, so you don't have to
              spend hours comparing prices manually.
            </p>
          </div>

          <div className="bg-gray-800/40 backdrop-blur-sm border border-gray-700/50 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">
              What We Offer
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="text-lg font-semibold text-blue-400 mb-2">
                  🎯 Comprehensive Selection
                </h3>
                <p className="text-gray-300">
                  Optics from leading brands including Holosun, Vortex, EOTech,
                  Trijicon, and more.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-blue-400 mb-2">
                  💰 Price Tracking
                </h3>
                <p className="text-gray-300">
                  Real-time price comparison across major retailers to help you
                  find s price within yout budget.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-blue-400 mb-2">
                  📊 Smart Filtering
                </h3>
                <p className="text-gray-300">
                  Filter by category, brand, magnification, reticle type, and
                  price range to find exactly what you need.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-blue-400 mb-2">
                  📈 Price Graphs
                </h3>
                <p className="text-gray-300">
                  Visual price comparison charts help you quickly identify the
                  best deals. *Coming Soon.*
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-800/40 backdrop-blur-sm border border-gray-700/50 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">
              Why Trust Us?
            </h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              We're passionate about helping fellow enthusiasts make informed
              purchasing decisions. Our price data is updated regularly, and we
              only feature reputable retailers with proven track records.
            </p>
            <p className="text-gray-300 leading-relaxed">
              Whether you're looking for a red dot, a long-range rifle scope for
              precision shooting, or an LPVO for versatile performance,
              OpticPicker has you covered.
            </p>
          </div>

          <div className="text-center">
            <button
              onClick={() => setCurrentPage("browse")}
              className="px-8 py-4 bg-blue-600 hover:bg-blue-500 text-white font-semibold rounded-xl transition shadow-lg shadow-blue-600/30"
            >
              Start Browsing Optics →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
